import axios from "axios";
import Comm from "./Comm";
import Numeral from "numeral";
import Comm2 from "./Comm2";

export default {
  Comm,
  Comm2,
  User: {
    /**
     * @desc 사용자 정보 가져오기(미로그인시 404)
     *
     * @returns {object||null}
     */
    getUserInfo() {
      return Comm("/v1/me").get();
    },
    /**
     * @desc 사용자의 개인 정보 가져오기
     *
     * @param {*} field email || phone || gender || realname || birthday || accounts(실계좌)
     * @returns
     */
    getUserPrivateInfo(field) {
      return Comm(`/v1/privacy/${field}`).post();
    },
    /**
     * @desc 거주지 증명 상태 조회
     *
     * @returns
     */
    getResidenceAuth() {
      return Comm("/v1/auth/residences").get();
    },
    /**
     * @desc 거주지 증명 신청
     *
     * @param {*} params
     * @returns
     */
    RequestResidenceAuth(params) {
      return Comm("/v1/auth/residences").post(params);
    },
    /**
     * @desc 휴대폰 번호 초기화 신청
     *
     * @param {*} params
     * @returns
     */
    RequestPhoneReset(params) {
      return Comm("/v1/auth/request-initialize").post(params);
    },
    /**
     * @desc 사용자 정보 갱신
     *
     * @param {*} param
     * @returns
     */
    updateUserInfo(param) {
      return Comm("/v1/me/update").post(param);
    },
    /**
     * @desc 회원 탈퇴
     *
     * @param {*} reason
     * @returns
     */
    leave(reason) {
      return Comm("/v1/me/delete").post({ reason });
    },
    /**
     * @desc 사용자 마케팅 동의 여부/시간 체크
     *
     * @param {*} params
     * @returns
     */
    getMarketingAgree(params) {
      return Comm("/v1/me/agreeTerms").get(params);
    },
    /**
     * @desc 사용자 접속 정보 조회
     *
     * @param {*} params
     * @returns
     */
    getConnectionInfo(params) {
      return Comm("/v1/me/connections").get(params);
    },
    /**
     * @desc 사용자 실명 조회
     *
     * @returns
     */
    getRealName() {
      return Comm("/v1/auth/realname").get();
    },
    /**
     * @desc 로그인
     *
     * @param {*} { id, pw, g_recaptcha_response }
     * @returns
     */
    logIn({
      id,
      pw,
      g_recaptcha_response,
      ali_token,
      ali_sig,
      ali_csessionid,
    }) {
      return Comm("/v1/login").post({
        email: id,
        password: pw,
        "g-recaptcha-response": g_recaptcha_response,
        ali_token,
        ali_sig,
        ali_csessionid,
      });
    },
    /**
     * @desc 비밀번호 다음에 변경하기
     *
     * @param {*} { email }
     * @returns
     */
    nextMemberInfo(params) {
      return Comm("/v1/auth/nextMemberInfo").post(params);
    },
    /**
     * @desc 로그아웃
     *
     * @returns
     */
    logOut() {
      return Comm("/v1/logout").get();
    },
    /**
     * @desc 회원가입
     *
     * @param {*} { email, password, g_recaptcha_response }
     * @returns
     */
    join({
      email,
      password,
      agreePromotion,
      agreePersonal,
      g_recaptcha_response,
      uuidx,
      ali_token,
      ali_sig,
      ali_csessionid,
    }) {
      return Comm("/v1/users").post({
        email,
        password,
        agreePromotion,
        agreePersonal,
        "g-recaptcha-response": g_recaptcha_response,
        uuidx,
        ali_token,
        ali_sig,
        ali_csessionid,
      });
    },
    /**
     * @desc 사용자 인증 정보 조회(GET::/me로 통합됨)
     * @deprecated
     *
     * @returns
     */
    getAuthInfo() {
      return Comm("/v1/auth").get();
    },
    /**
     * @desc 이메일로 가입여부 확인
     *
     * @param {*} email
     * @returns
     */
    getEmailInfo(email) {
      return Comm(`/v1/auth/${email}`).get();
    },
    /**
     * @desc 비밀번호 초기화 요청
     *
     * @param {*} { email, g_recaptcha_response }
     * @returns
     */
    resetPassword({ email, g_recaptcha_response }) {
      return Comm("/v1/auth/reset-password").post({
        email,
        "g-recaptcha-response": g_recaptcha_response,
      });
    },
    /**
     * 비밀번호 변경
     *
     * @param {*} { code, password }
     * @returns
     */
    changePassword({ code, password }) {
      return Comm("/v1/auth/reset-password/do").post({ code, password });
    },
    /**
     * @desc 비밀번호 초기화 이메일 전송
     *
     * @param {*} { address }
     * @returns
     */
    sendEmail({ address }) {
      return Comm("/v1/auth/email/send").post({ address });
    },
    /**
     * @desc 이메일 승인
     *
     * @returns
     */
    confirmEmail() {
      return Comm("/v1/auth/email/confirm").get();
    },
    /**
     * @desc 로그인 2차인증 문자 전송
     *
     * @returns
     */
    sendSMS() {
      return Comm("/v1/auth/sms/validators").get();
    },
    /**
     * @desc 2차인증 문자 인증 확인
     *
     * @param {*} { requestCode, authNumber }
     * @returns
     */
    validateSMS({ requestCode, authNumber }) {
      return Comm("/v1/auth/sms/validators").post({ requestCode, authNumber });
    },
    /**
     * @desc OTP 인증 등록
     *
     * @param {*} { secret, authNumber }
     * @returns
     */
    registOTP({ secret, authNumber }) {
      return Comm("/v1/auth/otp").post({ secret, authNumber });
    },
    /**
     * @desc OTP QR코드 생성
     *
     * @param {string} [recoveryCode='']
     * @returns
     */
    getOTPQrCode(recoveryCode = "") {
      return Comm("/v1/auth/otp/qr").post({ recoveryCode });
    },
    /**
     * @desc OTP 해제
     *
     * @param {*} authNumber
     * @returns
     */
    terminateOTP(authNumber) {
      return Comm("/v1/auth/otp/delete").post({ authNumber });
    },
    /**
     * @desc OTP 로그인 인증 확인
     *
     * @param {*} { means, token, authNumber }
     * @returns
     */
    validateOTP({ means, token, authNumber }) {
      return Comm("/v1/auth/otp/validators").post({ authNumber, token, means });
    },
    /**
     * @desc 2차 로그인 인증 요청(1차 로그인에서 토큰 발급 후, SMS 발송 등의 인증 시작 요청)
     *
     * @param {*} { token, means = 'SMS' }
     * @returns
     */
    requestAuth({ token, means = "SMS" }) {
      return Comm("/v1/login/step/2").get({ token, means });
    },
    /**
     * @desc 2차 로그인 인증 확인
     *
     * @param {*} { means, token, authvalue }
     * @returns
     */
    loginAuth({ means, token, authvalue }) {
      return Comm("/v1/login/step/2").post({ authvalue, token, means });
    },
    /**
     * @desc 실명인증 여부 확인
     *
     * @returns
     */
    getAuthResult() {
      return Comm("/v1/auth/realnameComplete").get();
    },
    /**
     * @desc 사용자 지갑 정보 가져오기
     *
     * @returns
     */
    getWallet() {
      return Comm(`/v2/wallets`).get({ noLoading: true });
    },
    /**
     * @desc  사용자 지갑 정보 디테일
     *
     * @param {string} [coinId='']
     * @returns
     */
    getWalletDetail(coinId = "") {
      return Comm(`/v2/wallets/coin/${coinId}`).get();
    },
    /**
     * @desc 사용자 지갑 생성
     *
     * @param {*} coinId
     * @returns
     */
    createWallet(coinId, params) {
      return Comm(`/v2/wallets/coin/${coinId}`).post(params);
    },
    /**
     * @desc 사용가 거래 내역
     *
     * @param {*} params
     * @returns
     */
    tradeHistory(params) {
      return Comm(`/v1/orders`).get(params);
    },
    /**
     * @desc 사용가 거래 내역
     *
     * @param {*} params
     * @returns
     */
    tradeOrderHistory(params) {
      return Comm(`/v2/orderHis`).get(params);
    },
    /**
     * @desc 사용자 지갑 주소 목록
     *
     * @param {*} params
     * @returns
     */
    getAddrList(params) {
      return Comm(`/v1/addresses`).get(params);
    },
    /**
     * @desc 사용자 지갑 주소 추가
     *
     * @param {*} params
     * @returns
     */
    addAddr(params) {
      return Comm(`/v1/addresses`).post(params);
    },
    /**
     * @desc 사용자 등록 지갑 주소 상세
     *
     * @param {*} addressId
     * @returns
     */
    getAddrDetail(addressId) {
      return Comm(`/v1/addresses/${addressId}`).get();
    },
    /**
     * @desc 사용자 등록 지갑 주소 수정
     *
     * @param {*} { addressId, ...params }
     * @returns
     */
    modifyAddr({ addressId, ...params }) {
      return Comm(`/v1/addresses/${addressId}`).put(params);
    },
    /**
     * @desc 사용자 등록 지갑 주소 삭제
     *
     * @param {*} addressId
     * @returns
     */
    deleteAddr(addressId) {
      return Comm(`/v1/addresses/${addressId}/delete`).post({ addressId });
    },
    /**
     * 계좌 실명 인증 (bonanaza)
     *
     * @param {*} { bankCode, accountNumber }
     */
    // registAccount({ bankCode, accountNumber }) {
    //   return Comm(`/v1/aspect/bonanza/doCheckRealName`).post({ bankCode, accountNumber });
    // },
    doCorporatePossess({ bankCode, accountNumber, deviceType }) {
      return Comm("/v1/aspect/bonanza/doCorporatePossess").post({
        bankCode,
        accountNumber,
        deviceType,
      });
    },
    doRegisterAccount({ procType, code, bankCode, accountNumber, deviceType }) {
      return Comm("/v1/aspect/bonanza/doRegisterAccount").post({
        procType,
        code,
        bankCode,
        accountNumber,
        deviceType,
      });
    },
    getAccountAvailableAmount({ bankCode, accountNumber }) {
      return Comm("/v1/aspect/bonanza/doAvailableAmount").post({
        bankCode,
        accountNumber,
      });
    },
    // 외국인 인증 관련
    /**
     * 국가 코드 가져오기
     */
    getCountryCodes() {
      return Comm("/v1country").get();
    },
    /**
     * 외국인 핸드폰 번호 인증코드 요청
     *
     * @param {string} name
     * @param {string} cntIdx
     * @param {string} cntLocalCode
     * @param {string} mPhone
     * @returns Promise
     */
    requestForeignPhoneAuthCode(name, cntidx, cntLocalCode, mPhone) {
      return Comm("/v1/auth/sms/foreignPhone").post({
        name,
        cntidx,
        cntLocalCode,
        mPhone,
      });
    },
    validateForeignPhoneAuthCode(
      name,
      cntidx,
      mPhone,
      requestCode,
      authNumber
    ) {
      return Comm("/v1/auth/sms/foreignPhoneValid").post({
        name,
        cntidx,
        mPhone,
        requestCode,
        authNumber,
      });
    },
    /**
     * 정보보기 호출
     *
     * @param {*}
     */
    getAuthUserInfo() {
      return Comm(`/v1/auth/cdd-edd/user-info`).get();
    },
    /**
     * @desc 거주지 증명 신청
     *
     * @param {*} params
     * @returns
     */
    RequestKYCAuth(params) {
      return Comm("/v1/auth/kyc-confirmations").post(params);
    },
    /**
     * 실명확인 입금계좌 발급. 검증횟수 조회
     *
     * @param {*} {}
     */
    registUserAccount() {
      return Comm(`/v1/account/getVerifyNumCnt`).post({});
    },
    /**
     * 실명확인 입금계좌 발급. 예금주성명 조회
     *
     * @param {*} {}
     */
    checkAccountHolder(params) {
      return Comm(`/v1/account/verifyAcntOwnName`).post(params);
    },
    /**
     * 실명확인 입금계좌 발급. 계좌점유인증 신청
     *
     * @param {*} {}
     */
    checkRealUserAccount(params) {
      return Comm(`/v1/account/reqAcntOwnership`).post(params);
    },
    /**
     * 실명확인 입금계좌 발급. 계좌점유인증 확인
     *
     * @param {*} {}
     */
    verifyAcntOccpCheck(params) {
      // confirmRealUserAccount(params) {
      return Comm(`/v1/account/verifyAcntOccpCheck`).post(params);
    },
    /**
     * 실명확인 입금계좌 발급. 가상계좌 매핑
     *
     * @param {*} {}
     */
    addVirtualAccount(params) {
      return Comm(`/v1/account/addVirtualAccount`).post(params);
    },
    /**
     * 계좌 실명 인증 (bonanaza)
     *
     * @param {*} { bankCode, accountNumber }
     */
    registAccount({ bankCode, accountNumber }) {
      return Comm(`/v1/aspect/bonanza/doCheckRealName`).post({
        bankCode,
        accountNumber,
      });
    },
    /**
     * @desc 이메일 중복 체크
     *
     * @param {*} email
     * @returns
     */
    checkValidEmail(email) {
      return Comm(`/v1/auth/validEmail`).post(email);
    },
  },
  Server: {
    getInnerSeverStatus() {
      return Comm("/v1/mobile/version").get();
    },
    getOuterSeverStatus() {
      const isProduction = window.location.host === "m.flybit.com";
      const timeStemp = +new Date();

      const setAxios = axios.create({
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        },
      });
      return setAxios.get(
        `https://s3-ap-northeast-2.amazonaws.com/flybit${
          isProduction ? "" : ".dev"
        }.front/version.json?timestamp=${timeStemp}`
      );
    },
  },

  // 계좌 실명 인증
  registAccount(params) {
    return Comm(`/v1/aspect/coocon/validate-account-realname`).post(params);
  },
  getAuthMeans() {
    return Comm("/v1/auth/means").get();
  },
  requestMeansToken(means) {
    return Comm(`/v1/auth/means/${means}/token`).get();
  },
  getKrwDays() {
    return Comm("/v1krw-days").get();
  },
  getFirstKrwDays() {
    return Comm("/v1first/krw-days").get();
  },
  isPolicyChange() {
    return Comm("/v1isPolicyChange").get();
  },
  // ocr version
  Auth: {
    /**
     * @desc ocr 주민등록증 진위여부
     *
     * @param {*}
     * @returns
     */
    confirmIdcard(params) {
      return Comm2(`/kr/public/mw/identity-card/status`).post(params);
    },
    /**
     * @desc ocr 운전면허증 진위여부
     *
     * @param {*}
     * @returns
     */
    confirmDriverLicense(params) {
      return Comm2(`/kr/public/ef/driver-license/status`).post(params);
    },
  },

  // 개인지갑 인증주소
  authAddr: {
    /**
     * @desc 인증 주소 서류신청
     *
     * @param {*}
     * @returns
     */
    secondAuthentication(params) {
      return Comm2(
        `/authentication/address/secondAuthentication/${acaidx}`
      ).post(params);
    },
    /**
     * @desc 인증 주소 리스트
     *
     * @param {*}
     * @returns
     */
    getAddresses() {
      return Comm2(`/authentication/addresses`).get();
    },
    /**
     * @desc 인증 주소 등록
     *
     * @param {*}
     * @returns
     */
    addAddresses(params) {
      return Comm2(`/authentication?/address/add`).post(params);
    },
    /**
     * @desc 인증 주소 삭제
     *
     * @param {*}
     * @returns
     */
    deleteAddresses(params) {
      return Comm2(`/authentication/address/del/${params.acaidx}`).post(params);
    },
    /**
     * @desc 인증 주소 수정
     *
     * @param {*}
     * @returns
     */
    modifyAddresses(params) {
      return Comm2(`/authentication/address/mod/${params.acaidx}`).post(params);
    },
    /**
     * @desc 개인 지갑 주소 체크
     *
     * @param {*}
     * @returns
     */
    getCheckAddresses(params) {
      return Comm2(`/authentication/address/validators`).get(params);
    },
    /**
     * @desc 코인별 인증 주소 리스트
     *
     * @param {*}
     * @returns
     */
    getAddressesByCoins(cidx) {
      return Comm2(`/authentication/addresses/${cidx}`).get();
    },
    /**
     * @desc 상세 인증 주소
     *
     * @param {*}
     * @returns
     */
    getDetailAddresses(params) {
      return Comm2(`/authentication/addressDetail/${acaidx}`).get(params);
    },
  },

  // 신원인증
  /**
   * @desc 개인정보 요청
   *
   * @param {*}
   * @returns
   */
  getMykeepinState(params) {
    return Comm2(`/auth/mykeepin/state/${params.type}`).get();
  },
  // /**
  //  * @desc 개인정보 요청(마이키핀 결과값)
  //  *
  //  * @param {*}
  //  * @returns
  //  */
  // identityInfo(params) {
  //   return Comm2(`/auth/mykeepin/identity-info`).post(params);
  // },
  /**
   * @desc 직업 data 받기
   *
   * @param {*}
   * @returns
   */
  getJobData() {
    return Comm2(`/centers/data/dueDiligence`).get();
  },
  // /**
  //  * @desc 최종 신원인증 정보 전달(mykeepin)
  //  *
  //  * @param {*}
  //  * @returns
  //  */
  // lastStepAuthInfo(params) {
  //   return Comm2(`/auth/cdd-edd/new-info`).post(params);
  // },
  /**
   * @desc 최종 신원인증 정보 전달(ocr ver)
   *
   * @param {*}
   * @returns
   */
  lastStepAuthInfo(identify, file1, file2) {
    return Comm(`/v1/auth/cdd-edd/add-info`).post(identify, file1, file2);
  },
  /**
   * @desc 외국인 최종 신원인증 정보 전달
   *
   * @param {*}
   * @returns
   */
  foreignerLastStepAuthInfo(params) {
    return Comm2(`/auth/cdd-edd/foreigner-new-info`).post(params);
  },
  /**
   * @desc 신원인증 외국인 국가 선택
   *
   * @param {*}
   * @returns
   */
  getCountry() {
    return Comm(`/v1/country`).get();
  },
  /**
   * @desc 신원인증 외국인 위험국가 여부
   *
   * @param {*}
   * @returns
   */
  getRiskCountry(country) {
    return Comm(`/v1/auth/cdd-edd/foreigner/risk/${country}`).get();
  },
  /**
   * @desc 신원인증 국내 거주 외국인 나이스 결과 호출
   *
   * @param {*}
   * @returns
   */
  getAuthResultForeigner() {
    return Comm(`/v1/auth/cdd-edd/foreigner/nice/complete`).get();
  },

  // AMPL rebase
  rebaseHistory(params) {
    return Comm(`/v1/rebaseHis`).get(params);
  },

  /**
   * @desc 외국인 국내 비거주 sms 인증번호 전송
   *
   * @param {*}
   * @returns
   */
  SMSAuthNumber(params) {
    return Comm2(`/auth/cdd-edd/foreigner/oversea/sms`).post(params);
  },

  /**
   * @desc 외국인 국내 비거주 sms 인증번호 검증
   *
   * @param {*}
   * @returns
   */
  verifySMSAuthNumber(params) {
    return Comm2(`/auth/cdd-edd/foreigner/oversea/sms/verify-number`).post(
      params
    );
  },

  /**
   * @desc 외국인 jSON 형식 호출 후 최종 이미지 전달
   *
   * @param {*}
   * @returns
   */
  lastForeignerImage(params2) {
    return Comm(`/v1/auth/cdd-edd/foreigner-img-info`).post(params2);
  },

  Transfer: {
    /**
     * @desc 사용자 입출금 내역 조회
     *
     * @param {*} params
     * @returns
     */
    getTransferHistory(params) {
      return Comm(`/v2/transfers`).get(params);
    },
    /**
     * @desc KRW 추가
     * @param {*} params
     */
    getKRWTransferHistory(params) {
      return Comm(`/v1/transfers/krw/remittance-logs`).get(params);
    },
    getKRWReady(params) {
      return Comm(`/v1/transfers/krw/remittance-ready-logs`).get();
    },
    /**
     * @desc 입금대기내역 취소
     * @param {*} params
     */
    transferCancelKRW(params) {
      return Comm(`/v2/transfers/krw/cancelKRW`).post(params);
    },
    transferStatusKRW(params) {
      return Comm(`/v2/transfers/krw/statusKRW`).post(params);
    },
    /**
     * @desc 지갑 입출금
     *
     * @param {*} params
     * @returns
     */
    transferAsset(params) {
      return Comm(`/v2/transfers`).post(params);
    },
    /**
     * KRW transfer
     * @param {*}} params
     */
    transferKRW({ mode, ...params }) {
      return Comm(`/v2/transfers/krw/${mode}`).post(params);
    },
    /**
     * @desc 입출금 내역 상세
     *
     * @param {*} transferId
     * @returns
     */
    getTransferDetail(transferId) {
      return Comm(`/v1/transfers/${transferId}`).get();
    },
    /**
     * @desc 입출금 내역 삭제
     * @deprecated
     *
     * @param {*} transferId
     * @returns
     */
    deleteTransfer(transferId) {
      return Comm(`/v1/transfers/${transferId}`).delete();
    },
    /**
     * @desc 입출금 한도 조회
     *
     * @param {*} coinId
     * @returns
     */
    getWithdrawLimit(coinId) {
      return Comm(`/v1/wallets/coin/${coinId}/withdrawal-limit`).get();
    },
    confirmRemittance(
      [upfile1, upfile2, upfile3],
      { ali_token, ali_sig, ali_csessionid }
    ) {
      return Comm(`/v1/auth/remittance-confirmations`).post({
        upfile1,
        upfile2,
        upfile3,
        noLoading: true,
        ali_token,
        ali_sig,
        ali_csessionid,
      });
    },
    registRemittance(logs) {
      return Comm(`/v1/transfers/krw/remittance-logs`).post({
        logs: JSON.stringify(logs),
      });
    },
    /**
     * @desc 가상자산 내부 전송, 내부 받는 주소 확인
     *
     * @param {string} [orderId='']
     * @returns
     */
    checkDepositInnerAddress(coinId, addr, destTag, vaspId) {
      return Comm(`/v1/wallets/coin/${coinId}/localValid`).post({
        addr,
        destTag,
        vaspId,
      });
    },
    /**
     * @desc only USDT
     *
     * @param
     * @returns
     */
    getCoinsInfo() {
      return Comm(`/v1/coins`).get();
    },
    /**
     * @desc only USDT
     *
     * @param {string} [coinId='']
     * @returns
     */
    getUSDTInfo() {
      return Comm(`/v1/coins/code/USDT`).get();
    },
    /**
     * @desc 트래블룰 거래소 리스트
     *
     * @param {string} [coinId='']
     * @returns
     */
    getExchangeLists() {
      return Comm(`/v1/travel/vasps`).get();
    },
    /**
     * @desc 트래블룰 주문 가능 체크
     *
     * @param {string} [coinId='']
     * @returns
     */
    confirmTravelRule(params) {
      return Comm2(`/travel/verifications`).post(params);
    },
    /**
     * @desc 트래블룰 100만원 이상 체크
     *
     * @param {string} [coinId='']
     * @returns
     */
    priceVerifications(params) {
      return Comm2(`/travel/priceVerifications`).post(params);
    },
  },
  Trade: {
    /**
     * @desc 호가창 정보 조회
     *
     * @param {string} [marketId='']
     * @returns
     */
    getOrderbook(marketId = "") {
      return Comm(`/v1/prices/call/${marketId}`).get();
    },
    /**
     * @desc 시/종/고/저 정보 조회
     *
     * @param {*} { marketId = '', ...params }
     * @returns
     */
    getTicker({ marketId = "", ...params }) {
      return Comm(`/v1/prices/daily/${marketId}`).get();
    },
    /**
     * @desc 현재가 조회
     *
     * @param {string} [marketId='']
     * @returns
     */
    // getCurrentPrice(marketId = "") {
    //   return Comm(`/v1/prices/current/${marketId}`).get();
    // },
    /**
     * @desc 현재가 조회(전체)
     * @returns
     */
    getCurrentPriceTotal() {
      return Comm(`/v2/prices/`).get();
    },
    /**
     * @desc 현재가 조회
     *
     * @param {string} [marketId='']
     * @returns
     */
    getCurrentPrice(marketId = "") {
      return Comm(`/v2/prices/${marketId}`).get();
    },
    /**
     * @desc 마지막 거래 조회
     *
     * @param {string} [marketId='']
     * @param {*} params
     * @returns
     */
    getLastTrade(marketId = "", params) {
      return Comm(`/v1/orders/dexko/${marketId}`).get(params);
    },
    /**
     * @desc 거래 주문
     *
     * @param {*} params
     * @returns
     */
    order(params) {
      return Comm(`/v1/orders`).post(params);
    },
    /**
     * @desc 미체결 거래 취소
     *
     * @param {string} [orderId='']
     * @returns
     */
    cancelOrder(orderId = "", params) {
      return Comm(`/v1/orders/${orderId}/delete`).post(params);
    },
  },
  Markets: {
    /**
     * @desc 마켓 정보 조회(marketId가 공백인 경우 전체 마켓)
     *
     * @param {string} [marketId='']
     * @returns
     */
    getMarketsLists() {
      return Comm(`/v2/markets`).get();
    },
    /**
     * @desc 마켓 정보 조회(marketId가 공백인 경우 전체 마켓)
     *
     * @param {string} [marketId='']
     * @returns
     */
    getMarkets(marketId = "") {
      return Comm(`/v2/markets/${marketId}`).get();
    },
    /**
     * @desc 코인 정보 조회(coinId가 공백인 경우 전체 코인)
     *
     * @param {string} [coinId='']
     * @returns
     */
    getKeyCoin(coinId = "") {
      return Comm(`/v1/markets/keycoin/${coinId}`).get();
    },
  },
  Setting: {
    /**
     * @desc Bonanza 이용약관
     *
     * @returns
     */
    getBonanzaTerms() {
      return Comm("/v1/centers/dexko/data/bonanza").get();
    },
    /**
     * @desc 거래소 목록 조회
     *
     * @returns
     */
    getCenterList() {
      return Comm(`/v1/centers`).get();
    },
    /**
     * @desc 코인 지갑 서버 현황 조회
     *
     * @param {*} { centerName, coinId = '' }
     * @returns
     */
    /**
     * 은행리스트
     */
    getBankList() {
      return Comm("/v1/centers/dexko/data/banks").get();
    },
    getCoinStatus({ centerName, coinId = "" }) {
      return Comm(`/v1/centers/${centerName}/coins/${coinId}`).get();
    },
    /**
     * @desc 코인 설정 정보 조회
     *
     * @param {string} [coinId='']
     * @returns
     */
    getCoinInfo(coinId = "") {
      return Comm(`/v1/coins/${coinId}`).get();
    },
    /**
     * @desc 이용약관 조회
     * @deprecated
     * @returns
     */
    getTerms() {
      return Comm("/v1/centers/dexko/data/terms-of-use").get();
    },
    /**
     * @desc 개인정보방침 조회
     * @deprecated
     * @returns
     */
    getPrivacy() {
      return Comm("/v1/centers/dexko/data/privacy").get();
    },
    /**
     * @desc 개인정보 수집/이용 동의(회원가입)
     * @deprecated
     * @returns
     */
    getCollection() {
      return Comm("/v1/centers/dexko/data/collection").get();
    },
    /**
     * @desc 개인정보 제3자 제공동의(회원가입)
     * @deprecated
     * @returns
     */
    getThirdTerm() {
      return Comm("/v1/centers/dexko/data/third").get();
    },
    /**
     * @desc 홍보 및 마케팅동의(회원가입)
     * @deprecated
     * @returns
     */
    getMarketing() {
      return Comm("/v1/centers/dexko/data/marketing").get();
    },
    /**
     * @desc 이용약관 목록 조회(과거 변경 내역 포함)
     *
     * @returns
     */
    getTermsList() {
      return Comm("/v1/centers/dexko/data/terms-of-uses").get();
    },
    /**
     * @desc 개인정보방침 조회(과거 변경 내역 포함)
     *
     * @returns
     */
    getPrivacyList() {
      return Comm("/v1/centers/dexko/data/privacies").get();
    },
    /**
     * @desc 덱스코 거래소 정보 조회
     *
     * @returns
     */
    getDexkoInfo() {
      return Comm("/v1/centers/dexko").get();
    },
    /**
     * 은행리스트
     */
    getBankList() {
      return Comm("/v1/centers/dexko/data/banks").get();
    },
  },
  Cs: {
    /**
     * @desc QnA 게시물 열람(questionId가 공백인 경우 게시물 전체, 공백이 아닌 경우 해당 아이디 게시물의 상세)
     *
     * @param {*} { questionId = '', ...params }
     * @returns
     */
    getQna({ questionId = "", ...params }) {
      return Comm(`/v1/questions/${questionId}`).get(params);
    },
    /**
     * @desc qna 등록
     *
     * @param {*} params
     * @returns
     */
    registQna(category, title, contents, ali_token, ali_sig, ali_csessionid) {
      return Comm("/v1/questions").post({
        category: category,
        title: title,
        contents: contents,
        // "g-recaptcha-response": g_recaptcha_response,
        ali_token: ali_token,
        ali_sig,
        ali_csessionid,
      });
    },
  },
  Board: {
    /**
     * @desc FAQ 게시물 열람(faqId 공백인 경우 게시물 전체, 공백이 아닌 경우 해당 아이디 게시물의 상세)
     *
     * @param {*} { faqId = '', ...params }
     * @returns
     */
    getFaq({ faqId = "", ...params }) {
      return Comm(`/v1/board/faqs/${faqId}`).get(params);
    },
    getNotice({ noticeId = "", ...params }) {
      return Comm(`/v1/board/notices/${noticeId}`).get(params);
    },
    // noticeId가 있는 경우 상세 정보
    // getNotice({ noticeId = '', ...params }) {
    //   return Comm(`/v1/board/notices/${noticeId}`).get(params);
    // },
    // newsId가 있는 경우 상세 정보
    // getNews({ newsId = '', ...params }) {
    //   return Comm(`/v1/board/news/${newsId}`).get(params);
    // },
    /**
     * @desc 기타 게시물 열람(faqId 공백인 경우 게시물 전체, 공백이 아닌 경우 item에 따라 게시판 타입 내용)
     *
     * @param {*} { itemId = '', ...params }
     * @returns
     */
    getItems({ ...params }) {
      return Comm(`/v1/board/items`).get(params);
    },
  },
  Chart: {
    /**
     * @desc 차트 정보 열람
     * @deprecated
     *
     * @param {*} chartPeriod
     * @param {*} params
     * @returns
     */
    getChartData(chartPeriod, params) {
      return Comm(`/v1/charts/period/${chartPeriod}`).get({
        ...params,
        noLoading: true,
      });
    },
    /**
     * @desc 세계 시세 열람
     *
     * @param {*} [{ centerId = 0, marketId = 0 }={}]
     * @returns
     */
    getWorldCurrency({ centerId = 0, marketId = 0 } = {}) {
      return Comm(`/v1/charts/world`).get({
        centerId,
        marketId,
        noLoading: true,
      });
    },
  },
  Aspect: {
    getWalletAddress({ coinCode = "", address = "", ...params }) {
      return Comm(
        `/aspect/validator/wallet-address/${coinCode}/${address}`
      ).get(params);
    },
    doAppDnSms() {
      return Comm("/v1/aspect/bonanza/appDnSms").get();
    },
    getAccountFailCount() {
      return Comm("/v1/aspect/bonanza/accountFailCnt").get();
    },
  },
  IEO: {
    getSaleList() {
      return Comm(`/v1/ieo/tokenSaleList`).get();
    },
    getSaleDetail(tkCode) {
      return Comm(`/v1/ieo/tokenSaleDetail`).get({ tkCode });
    },
    getSaleHistory(tkCode) {
      return Comm(`/v1/ieo/tokenSaleOrderList`).get({ tkCode });
    },
    requestIEOSale(params) {
      return Comm(`/v1/ieo/tokenSale`).post(params);
    },
  },
};
